module.exports = __webpack_public_path__ + "img/relieved.10e5ab27.png";